import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useSearchStore = defineStore('search', () => {
  const trips = ref([])
  const searchParams = ref({
    startCity: '',
    endCity: '',
    dateToStart: ''
  })

  function setSearchResults(tripsData, params) {
    trips.value = tripsData
    searchParams. value = params
  }

  function clearSearchResults() {
    trips.value = []
    searchParams.value = {
      startCity: '',
      endCity: '',
      dateToStart: ''
    }
  }

  return {
    trips,
    searchParams,
    setSearchResults,
    clearSearchResults
  }
})
